(function () {
  var KEY = 'sur3a-wishlist';
  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
  function sync() {
    var list = read();
    document.querySelectorAll('[data-s3-wish]').forEach(function (b) {
      b.setAttribute('aria-pressed', list.indexOf(b.getAttribute('data-s3-wish')) > -1 ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-s3-wish]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = b.getAttribute('data-s3-wish');
    var list = read();
    var i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.push(handle);
    write(list);
    sync();
  });
  var timer;
  new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(sync, 50); }).observe(document.body, { childList: true, subtree: true });
  sync();
})();